<ncp-table #devicesImplants [(options)]="options"></ncp-table>
